import React from 'react';
import ReactModal from 'react-modal';
import { LayeringConsumer, LayeringProvider } from '@rescui/ui-contexts';
import { CloseIcon, LoadingIcon } from '@rescui/icons';
import { RemoveScrollBar } from 'react-remove-scroll-bar';
import Button from '@rescui/button';
import styles from './popup.module.pcss.js';

const Popup = ({
  isOpen,
  children,
  onRequestClose,
  shouldCloseOnEsc = true,
  shouldCloseOnOverlayClick = true,
  busy = false,
  showOuterCloseButton = false,
  ariaHideApp = false,
  ...restProps
}) => {
  return React.createElement(LayeringConsumer, null, ({
    popupZIndex
  }) => React.createElement(LayeringProvider, {
    baseLayer: "popup"
  }, React.createElement(ReactModal, {
    isOpen: isOpen,
    className: styles.popup,
    overlayClassName: styles.overlay,
    onRequestClose: onRequestClose,
    shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
    shouldCloseOnEsc: shouldCloseOnEsc,
    ...restProps,
    ariaHideApp: ariaHideApp,
    style: {
      overlay: {
        zIndex: popupZIndex
      }
    }
  }, !busy && showOuterCloseButton && React.createElement(Button, {
    mode: 'rock',
    theme: 'light',
    icon: React.createElement(CloseIcon, null),
    className: styles.close,
    onClick: onRequestClose,
    "data-test": "close-button"
  }), busy ? React.createElement(LoadingIcon, {
    size: "l",
    theme: "dark",
    mode: "rock",
    "data-test": "loading-icon"
  }) : children, React.createElement(RemoveScrollBar, {
    gapMode: "margin"
  }))));
};

export { Popup };
